import { ChevronLeft, ChevronRight, Pause, Play } from 'lucide-react';
import { useEffect, useState } from 'react';
import "./ShiftCarousel.css"

const slides = [
  {
    image: '/assets/carousel-shift.webp',
    kicker: 'A permanent change of ground',
    title: 'From machine-first systems to human-led intelligence.',
    text: 'The center of gravity moves from imitation to origin  and technology moves from conductor to instrument.',
  },
  {
    image: '/assets/carousel-scale.webp',
    kicker: 'The true scale of intelligence',
    title: 'Computation is powerful. Intelligence is larger.',
    text: 'Human intelligence adds discernment, intuition, conscience, empathy, perception and restraint to processing power.',
  },
  {
    image: '/assets/carousel-harmony.webp',
    kicker: 'The architecture of harmony',
    title: 'The machine plays. Humanity sings.',
    text: 'A co-creative relationship in which systems extend human capacity without replacing human judgment or meaning.',
  },
];

export default function ShiftCarousel() {
  const [active, setActive] = useState(0);
  const [playing, setPlaying] = useState(true);

  useEffect(() => {
    if (!playing) return undefined;
    const timer = window.setInterval(() => setActive((current) => (current + 1) % slides.length), 5200);
    return () => window.clearInterval(timer);
  }, [playing]);

  const move = (direction) => {
    setActive((current) => (current + direction + slides.length) % slides.length);
  };

  return (
    <section className="shift-section section" id="shift">
      <div className="container">
        <div className="section-heading reveal">
          <span className="eyebrow"><i /> The Big Shift</span>
          <h2>Reordering the relationship between human and machine.</h2>
          <p>Three perspectives from the Symphonia framework.</p>
        </div>

        <div className="carousel reveal">
          <div className="carousel__viewport">
            {slides.map((slide, index) => (
              <article
                className={`carousel__slide ${index === active ? 'carousel__slide--active' : ''}`}
                key={slide.title}
                aria-hidden={index !== active}
              >
                <img src={slide.image} alt="" />
                <div className="carousel__overlay" />
                <div className="carousel__content">
                  <span>{slide.kicker}</span>
                  <h3>{slide.title}</h3>
                  <p>{slide.text}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="carousel__controls">
            <div className="carousel__progress" aria-label="Carousel slides">
              {slides.map((slide, index) => (
                <button
                  type="button"
                  key={slide.title}
                  className={index === active ? 'is-active' : ''}
                  onClick={() => setActive(index)}
                  aria-label={`Show slide ${index + 1}`}
                >
                  <span />
                </button>
              ))}
            </div>
            <div className="carousel__buttons">
              <button type="button" onClick={() => setPlaying((value) => !value)} aria-label={playing ? 'Pause carousel' : 'Play carousel'}>
                {playing ? <Pause size={17} /> : <Play size={17} />}
              </button>
              <button type="button" onClick={() => move(-1)} aria-label="Previous slide"><ChevronLeft size={19} /></button>
              <button type="button" onClick={() => move(1)} aria-label="Next slide"><ChevronRight size={19} /></button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
